export default "__VITE_ASSET__CX4blyX8__"